import { createFileRoute } from "@tanstack/react-router";
import LpInstagram from "@/pages/LpInstagram";
import { SITE_URL } from "@/lib/site-url";

const URL = `${SITE_URL}/lp/instagram`;
const EN_URL = `${SITE_URL}/en/lp/instagram`;
const SHARE_TITLE = "Haz crecer tu negocio a pie de calle";
const SHARE_DESC = "El apoyo y el método que muchos dueños no tienen. Pruébalo gratis.";
const TITLE = "No decidas solo tu negocio | Retail Lemon";
const DESCRIPTION =
  "Panel, método y apoyo para negocios a pie de calle: caja, equipo, local y prioridades. Únete al acceso anticipado.";

export const Route = createFileRoute("/lp/instagram")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: SHARE_TITLE },
      { property: "og:description", content: SHARE_DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { property: "og:image", content: `${SITE_URL}/og-retail-lemon.jpg` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: SHARE_TITLE },
      { name: "twitter:description", content: SHARE_DESC },
      { name: "twitter:image", content: `${SITE_URL}/og-retail-lemon.jpg` },
      {
        name: "robots",
        content: "index, follow, max-image-preview:large, max-snippet:-1",
      },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "es", href: URL },
      { rel: "alternate", hrefLang: "en", href: EN_URL },
      { rel: "alternate", hrefLang: "x-default", href: URL },
    ],
  }),
  component: LpInstagram,
});
